import { lazy } from "react";
import { withPageLoader } from "@tecorien/mimic";
import { links } from "links";
import { getCreatePathTemplate, getEntityPathTemplate } from "navigation";
import { Permissions } from "permissions";
import { RouteDescription } from "types";

const TagListPage = lazy(() => import("./TagListPage"));
const TagPage = lazy(() => import("./TagPage"));

export const tagsRoutes: RouteDescription[] = [
  {
    path: links.tag,
    element: withPageLoader(<TagListPage />),
    breadcrumb: "Tags",
    menuItem: {
      id: "tags",
      label: "Tags",
    },
    requiredOneOfPermissions: [ Permissions.SuperAdmin ]
  },
  {
    path: getCreatePathTemplate(links.tag),
    element: withPageLoader(<TagPage />),
    breadcrumb: "Create new tag",
    requiredOneOfPermissions: [ Permissions.SuperAdmin ]
  },
  {
    path: getEntityPathTemplate(links.tag),
    element: withPageLoader(<TagPage />),
    breadcrumb: "Tag",
    requiredOneOfPermissions: [ Permissions.SuperAdmin ]
  },
];

